export default function getStripeAccount(seller = {}) {
  return seller.paymentGateways?.stripe?.userId;
}
